import { create, RequestTransform } from "apisauce";
import caller from "./helpers/caller";

import { SessionStorage } from "../utils";

const apiUrl = process.env.REACT_APP_API;

const api = create({
  baseURL: apiUrl,
  timeout: 500000,
});

api.addRequestTransform((request: any) => {
  const token = SessionStorage.getItem("token");

  if (token) {
    request.headers.authorization = token;
  }
});

api.addMonitor((response: any) => {
  const token = response.headers.authorization;

  if (token) {
    SessionStorage.setItem("token", token);
  }
});

async function getToken(loginData) {
  return caller(api.post, "/auth/sign_in", null, loginData);
}
async function sendRecoveryPasswordRequest(data) {
  return caller(
    api.post,
    `/access/password_reset_request?email=${data.email}`,
    null
  );
}

async function recoveryPasswordValidate(data) {
  return caller(api.post, "/access/password_reset_code", null, data);
}

async function sendRecoveryPasswordNewPassword(data) {
  return caller(
    api.post,
    `/access/password_reset_confirmation`,
    null,
    data.body,
    {
      headers: { Authorization: "Bearer " + data?.token },
    }
  );
}
// {  headers: { "Access-Control-Allow-Origin": "*" }}
async function getUserData(data) {
  return caller(api.get, "/user/find_current", null, data);
}

async function putChangePassword(data) {
  return caller(api.post, "/access/redefinition", null, data);
}
async function getReservation(data) {
  return caller(
    api.get,
    `/reservation/public/${data.reservationId}/${data.renterId}`,
    null,
    data
  );
}
async function getGuestsReservation(data) {
  return caller(
    api.get,
    `/visitant/reservation/public/reservation/${data.reservationId}`,
    null,
    null
  );
}
async function getSPReservation(data) {
  return caller(
    api.get,
    `/serviceprovider/reservation/public/reservation/${data.serviceprovider}`,
    null,
    null
  );
}
async function getTenantReservation(data) {
  return caller(
    api.get,
    `/tenant/reservation/public/reservation/${data.tenantId}`,
    null,
    null
  );
}

async function getImage(id) {
  return caller(
    api.get,
    `/document/image/${id}/download`,
    async (response: any) => {
      async function blobToBase64(blob: Blob): Promise<string> {
        return new Promise<string>((resolve, reject) => {
          const reader = new FileReader();

          reader.onloadend = () => {
            if (reader.result) {
              const base64String = reader.result as string;
              resolve(base64String);
            } else {
              reject(new Error("Failed to convert Blob to Base64."));
            }
          };

          reader.onerror = () => {
            reject(new Error("Error reading Blob."));
          };

          reader.readAsDataURL(blob);
        });
      }
      try {
        const base64Result = await blobToBase64(response.data);
        return { ...response, data: base64Result };
      } catch (error: any) {
        console.error("Error:", error.message);
        return { ...response };
      }
    },
    null,
    {
      responseType: "blob",
    }
  );
}

async function renderAll(data) {
  return caller(api.put, `/renter/all`, null, data);
}
async function renderGuest(data) {
  return caller(api.put, `/renter`, null, data);
}

async function updateVisitant(data) {
  return caller(api.put, `/visitant/reservation`, null, data);
}

async function updateSP(data) {
  return caller(api.put, `/serviceprovider/reservation`, null, data);
}

async function updateTenant(data) {
  return caller(api.put, `/tenant/reservation`, null, data);
}

async function verifyImage(data) {
  return caller(api.post, `/facial/detect`, null, {
    base64: data
  });
}

async function validateImage(imageData){
  return caller(api.post, "/facial/validate", null, imageData)
}

async function putRenterData(data) {
  return caller(api.put, `/renter/public`, null, data);
}

const apiServices = {
  sendRecoveryPasswordRequest,
  sendRecoveryPasswordNewPassword,
  recoveryPasswordValidate,

  getToken,

  getUserData,

  putChangePassword,
  getReservation,
  getGuestsReservation,
  getSPReservation,
  getTenantReservation,
  getImage,
  renderGuest,
  updateVisitant,
  updateSP,
  updateTenant,
  renderAll,

  putRenterData,
  verifyImage,
  validateImage
};

export default apiServices;
